import { render, staticRenderFns } from "./WaysTable.vue?vue&type=template&id=e8d86ad0"
import script from "./WaysTable.vue?vue&type=script&lang=js"
export * from "./WaysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports